import { parseInteger } from '../../../util/utility';
import { CXoneEvent } from './cxone-event';
/**
 * Class to capture agent queues API
 */
export class Queue extends CXoneEvent {
  /**
   * @remarks - Unique identifier for business unit(Tenant)
   */
  businessUnitId!: number;

  /**
   * @remarks - Unique identifier for Skill
   */
  skillId!: number;

  /**
   * @remarks - Name of Skill
   */
  skillName!: string;

  /**
   * @remarks - Unique identifier for Campaign
   */
  campaignId!: number;

  /**
   * @remarks - Type of Media
   */
  mediaType!: number;

  /**
   * @remarks - Total count of the contact
   */
  queueCount!: number;

  /**
   * @remarks - Longest queue time
   */
  longestQueueTimeInSeconds!: string;

  /**
   * @remarks - Earliest queue time
   */
  earliestQueueTimeInUTC!: Date;

  /**
   * @remarks - Unique identifier for Agent
   */
  agentId!: number;

  /**
   * This method to parse agent queue data
   * @param data - Agent queues data
   * @example -
   * ```
   * parse(data);
   * ```
   */
  parse(data: { [key: string]: string }): void {
    this.businessUnitId = parseInteger(data.businessUnitId);
    this.skillId = parseInteger(data.skillId);
    this.skillName = data.skillName;
    this.campaignId = parseInteger(data.campaignId);
    this.mediaType = parseInteger(data.mediaType);
    this.queueCount = parseInteger(data.queueCount);
    this.longestQueueTimeInSeconds = data.longestQueueTimeInSeconds;
    this.earliestQueueTimeInUTC = new Date(data.earliestQueueTimeInUTC);
    this.agentId = parseInteger(data.agentId);
  }
}

export interface AgentQueues {
  [key: string]: Queue;
}
